import React from 'react'

import classnames from 'classnames'

import type { ApiImage } from '@library/api-menu-experience'

import css from './GradientInfoHeader.css'

export type GradientInfoHeaderProps = {
  gradientColor?: string
  color?: string
  headerImage?: ApiImage
  image?: ApiImage
  description: string
  altText?: string
}

const GradientInfoHeader = ({
  gradientColor,
  color,
  headerImage,
  image,
  description,
  altText = 'Campaign banner',
}: GradientInfoHeaderProps) => {
  const titleImage = headerImage?.crops[0]
  const mainImage = image?.crops[0]

  return (
    <div className={css.gradientInfoHeader} data-testid="gradient-info-header">
      <div className={css.gradientImageBackground} data-testid="gradient-image-background">
        {mainImage && (
          <img
            className={css.gradientImage}
            src={mainImage.url}
            alt={image?.altText || altText}
            data-testid="gradient-info-header-main-image"
          />
        )}
        <div
          className={classnames(css.gradientBackground, css.hideMobile)}
          style={{
            backgroundImage: `linear-gradient(270deg, rgba(0, 83, 199, 0) 20%, ${gradientColor} 30%)`,
          }}
          data-testid="gradient-background-mobile"
        />
        <div
          className={classnames(css.gradientBackground, css.hideDesktop)}
          style={{
            backgroundImage: `linear-gradient(270deg, rgba(0, 83, 199, 0) 26.58%, ${gradientColor} 55%)`,
          }}
          data-testid="gradient-background-desktop"
        />
        <div
          className={css.gradientText}
          style={{
            color: `${color}`,
          }}
          data-testid="gradient-info-text"
        >
          {titleImage && (
            <img
              data-testid="gradient-info-header-image"
              src={titleImage.url}
              alt={headerImage?.altText || altText}
              style={{ width: 200, height: 'auto' }}
              className={css.gradientTitleImage}
            />
          )}
          <p className={css.gradientDescription} data-testid="gradient-description">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}

export { GradientInfoHeader }
